export default {
  common: {
    inputIntegerTip: '正の整数を入力してください'
  },
  company: {
    companySetting: 'エンタープライズ構成',
    userCount: '登録人数',
    expirationDate: 'アカウント有効期間',
    confirmedAccount: 'アカウントを確認する',
    confirmedAccountTip: '現在のアカウントを有効にしますか?'
  },
  licensePlate: {
    successTotal: '成功した合計数'
  },
  email: {
    details: 'メールの詳細',
    server: 'メールボックス サーバー',
    port: 'ポート',
    account: '電子メールアドレス',
    password: 'パスワード',
    sendername: '送信者名',
    sender: '差出人',
    recipient: '受取人',
    subject: '件名',
    sendTime: '送信時刻',
    status: '状態',
    emailsExpiryTip: 'アカウントの有効期限を通知',
    cronVal: 'メール送信頻度（日）',
    testConnection: 'テスト接続',
    save: '保存',
    threshold: 'アカウントの有効期限満了までの通知日',
    failReason: '失敗の理由',
    content: 'メールの内容'
  },
  inspection: {
    sn: 'デバイス№',
    exceptionType: '状態',
    timesTip: 'アルコールチェッカーの使用回数（残数／上限）',
    daysTip: 'アルコールチェッカーの使用日数（残日数／上限）',
    memory: 'メモリ (使用可能/合計) M',
    normal: '正常',
    exception: '異常な',
    warning: '暖かい',
    storage: 'ストレージ (利用可能/合計) M',
    inspectionTime: '検査時間',
    warningContent: 'デバイス状態情報',
    warningTime: '情報出力時刻',
    companyCode: '企業番号',
    name: '会社名',
    expiryData: '有効期限',
    status: '状態',
    onLine: 'オンライン',
    expired: '期限切れ{number}日',
    expiringSoon: '{number}日後に期限切れになる',
    offLine: 'オフライン',
    companyNumber: '会社数',
    inspectionTableTitle: '設備点検警報報告',
    companyExpiryTableTitle: 'エンタープライズ有効期間レポート'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/ja/v1.js